<div class="favorite-button-wrapper" *ngIf="clientUserService.isLoggedIn()" (click)="favoriteButtonClick($event)">
    <lib-icon-button
        iconName="heart-fill"
        [color]="isFavorite ? color : 'var(--ion-color-dark-40)'"
        [borderColor]="borderColor"
        backgroundColor="rgba(255, 255, 255, 0.6)"
        [backgroundFocusedColor]="borderColor"
        [backgroundHoverColor]="borderColor"
        [border]="true"
        [rippleColor]="borderColor"
        (onClick)="onButtonClick()"
        display="circle"
        [size]="28"
        [buttonSize]="40" />
</div>
